import { ReactComponent as AdminOptionsSvg } from "../../assets/images/svgs/adminOptions.svg";

const AdminOptionsIcon = ({ className = "", ...props }) => {
  return (
    <AdminOptionsSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AdminOptionsIcon;
